import { Skeleton } from '@/components/ui/skeleton';

export const InspectorSkeleton = () => {
  return (
    <div className="p-4 space-y-4 animate-pulse">
      {/* Header skeleton */}
      <div className="space-y-2">
        <Skeleton className="h-6 w-1/2" />
        <Skeleton className="h-4 w-3/4" />
        <div className="flex items-center space-x-2 pt-2">
          <Skeleton className="h-6 w-20 rounded-full" />
        </div>
      </div>

      {/* Divider */}
      <Skeleton className="h-px w-full" />

      {/* Tabs skeleton */}
      <div className="flex space-x-2 border-b">
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} className="h-9 w-24 rounded" />
        ))}
      </div>

      {/* Tab content skeleton */}
      <div className="space-y-3 pt-2">
        {[1, 2, 3, 4, 5].map((i) => (
          <Skeleton key={i} className="h-5 w-full" />
        ))}
      </div>
    </div>
  );
};
